// @flow
import React from 'react'
import {graphql} from 'react-relay'
import {ElasticSearchRailsSelect} from 'components/ui/forms/RailsSelect'

type Props = {
  name: string,
  orgDatabaseId: string,
  value?: {databaseId: string, title: string, circleName: string} | null,
};

const railsProjectSelectQuery = graphql`
  query RailsProjectSelectQuery(
    $orgDatabaseId: String!,
    $type: String!,
    $keywords: String,
    $fetchAllWhenEmpty: Boolean!,
    $count: Int!,
    $after: String
  ) {
    organization(databaseId: $orgDatabaseId) {
      esSearchResults(
        type: $type,
        keywords: $keywords,
        fetchAllWhenEmpty: $fetchAllWhenEmpty,
        first: $count,
        after: $after
      ) {
        edges {
          node {
            databaseId
            title
            circleName
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`

function RailsProjectSelect({name, orgDatabaseId, value}: Props): React$Node {
  const formatOptionData = (node) => ({
    value: node.databaseId,
    label: node.title,
    subtitle: I18n.t('shared.role_in_circle_simple', {circle_name: node.circleName}),
  })

  return (
    <ElasticSearchRailsSelect
      name={name}
      orgDatabaseId={orgDatabaseId}
      query={railsProjectSelectQuery}
      selectedOption={value?.databaseId ? formatOptionData(value) : null}
      type="Project"
      formatOptionData={formatOptionData}
      itemsPerPage={50}
    />
  )
}

export default RailsProjectSelect
